import { Box, type BoxProps, type MantineSpacing } from "@mantine/core"
import type { PropsWithChildren } from "react"

interface IProps extends BoxProps {
  colSize: number
  rowSize?: number
  gap?: MantineSpacing
}

export function AutoGrid({ children, colSize, rowSize, gap, style, ...props }: PropsWithChildren<IProps>) {
  return (
    <Box
      {...props}
      style={{
        display: "grid",
        gridGap: `var(--mantine-spacing-${gap || "xl"})`,
        gridTemplateColumns: `repeat(auto-fill, ${colSize}px)`,
        gridAutoRows: rowSize ? `${rowSize}px` : "auto",
        ...style,
      }}
    >
      {children}
    </Box>
  )
}
